module.exports = __webpack_public_path__ + "img/accountService.953a3022.png";